import React, { useRef } from 'react';
import '../App.css';

interface SpotifyPopupProps {
  onClose: () => void;
}

const SpotifyPopup: React.FC<SpotifyPopupProps> = ({ onClose }) => {
  const popupRef = useRef<HTMLDivElement>(null);

  return (
    <div className="welcome-popup-overlay">
      <div 
        className="welcome-popup spotify-popup"
        ref={popupRef}
      >
        <button className="welcome-popup-close" onClick={onClose}>×</button>
        
        <h2 className="welcome-popup-title">הקשיבו לפודקאסט ה-Roadmap!</h2>
        
        <div className="welcome-popup-content">
          <div className="welcome-popup-author">
            <p className="welcome-popup-author-intro">
              <strong>תקשיבו לפודקאסט ה-Roadmap</strong> - אני מסביר את התהליך, הטיפים והאסטרטגיות למציאת עבודה בהייטק.
            </p>
          </div>
          
          <p className="welcome-popup-intro">
            בפודקאסט אני מפרט את כל השלבים המוצגים במפה ומספק טיפים נוספים שיעזרו לכם להתכונן לתהליך חיפוש העבודה.
          </p>
          
          <div className="spotify-embed-container">
            <iframe
              src="https://open.spotify.com/embed/episode/2PRIFFbDL00GTm9bkfke6Q?utm_source=generator"
              width="100%"
              height="152"
              frameBorder="0"
              allowTransparency={true}
              allow="encrypted-media"
              title="Spotify Embed"
            ></iframe>
          </div>
          
          <div className="instruction-item">
            <span className="instruction-icon">🎧</span>
            <div className="instruction-text">
              <strong>האזינו בדרך:</strong> הפודקאסט מושלם להאזנה בזמן נסיעה, ספורט, או בכל זמן אחר.
            </div>
          </div>
          
          <div className="instruction-item">
            <span className="instruction-icon">📋</span>
            <div className="instruction-text">
              <strong>מידע משלים:</strong> הפודקאסט מכיל מידע שמשלים את המפה האינטראקטיבית.
            </div>
          </div>
          
          <div className="welcome-popup-footer">
            <button className="welcome-popup-button" onClick={onClose}>
              הבנתי, המשך למפה
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotifyPopup;